import Query from '@atlassian/jira-relay/src/__generated__/IssueTransitionModalQuery$parameters';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { Variables } from '../types.tsx';

const resource = JSResourceForInteraction(
	() => import(/* webpackChunkName: "async-jira-issue-transition-entrypoint" */ './index'),
);

const getPreloadProps = (variables: Variables) => ({
	queries: {
		issueTransitionInitialQueryRef: {
			parameters: Query,
			variables,
			options: {
				fetchPolicy: 'network-only' as const,
			},
		},
	},
});
export const asyncIssueTransitionModal = createEntryPoint({
	root: resource,
	getPreloadProps,
});
